export default __webpack_public_path__ + "static/media/DSC_7635.96aefad6.jpg";